export const OBJECTIVE_LABELS: Record<string, string> = {
  PENETRATION: 'Share Growth',
  SALES: 'Volume Growth',
};

export const SECONDARY_GOAL_LABELS: Record<string, string> = {
  VELOCITY: 'Velocity',
  VOLUME: 'Volume',
  SHARE: 'Share',
};

export const AUDIENCE_TYPE_LABELS: Record<string, string> = {
  NONE: 'No Audience',
  EXISTING: 'Existing Audience',
  NEW: 'New Audience',
};
